<template>
  <div>جاري المعالجة...</div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';

const { mapActions } = createNamespacedHelpers('AuthenticationModule');

export default {
  name: 'auth-login',
  mounted () {
    this.login(this.$route.query.redirect_url);
  },
  methods: {
    ...mapActions({
      login: 'authenticateOidc',
    }),
  },
};
</script>
